import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const WhyBuySectionStyle = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.whiteText};
  margin: 0 auto;
  width: 1200px;
  border-radius: 16px;
  padding: 40px;
  gap: 32px;
`;

export const WhyBuySectionTitle = styled.h2`
  color: ${theme.blackText};
  font-weight: 900;
  font-size: 32px;
`;

export const WhyBuySectionDescription = styled.p`
  font-weight: 400;
  color: ${theme.greyText};
  font-size: 16px;
  width: 80%;
`;

export const WhyBuySectionCustomNumbers = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const WhyBuySectionCustomNumber = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 175px;
`;

export const WhyBuySectionCustomNumberTitle = styled.h3`
  font-weight: 900;
  font-size: 32px;
`;

export const WhyBuySectionCustomNumberInfo = styled.span`
  color: ${theme.greyText};
  font-weight: 400;
  font-size: 16px;
`;
